import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Title', prop: 'title' },
  { title: 'Start', prop: 'start_at', format: 'dateWithTime' },
  { title: 'Num Registrants', prop: 'num_registrants' },
  { title: 'Published', prop: 'published_at', format: 'bool' }
]

const filters = [
  { name: 'Filter by title', prop: 'filters.title_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const Webinars = props => {
  const { courseId, curriculumId } = props.params
  let seriesId
  let type = 'guest'
  let label = 'Guest'
  if (courseId) {
    seriesId = courseId
    type = 'course'
    label = 'Course'
  } else if (curriculumId) {
    seriesId = curriculumId
    type = 'curriculum'
    label = 'Curriculum'
  }

  return (
    <List
      title={`${label} Webinars`}
      apiPath='admin/webinars'
      columns={columns}
      filters={filters}
      fixedFilters={{
        series_id: seriesId,
        type: type
      }}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
    />
  )
}

export default Webinars
